export const PASSWORD_VALIDATOR_MESSAGE = 'Password entries did not match'
export const PASSWORDS_TIPS_MESSAGE = 'Passwords do not match'